import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import { useTranslation } from "react-i18next";

function BathroomPage() {
    const { t } = useTranslation();
    const directory= "/images/mpanio/";
    const filenames=[
       'VPR02421_Vasso_Paraschi.webp',
        'VPR02427_Vasso_Paraschi.webp',
        'VPR02466_Vasso_Paraschi.webp',
        'VPR02476_Vasso_Paraschi.webp',
        'VPR02536_Vasso_Paraschi.webp',
        'VPR02565_Vasso_Paraschi.webp',
        'VPR02569_Vasso_Paraschi.webp',
        'VPR02571_Vasso_Paraschi.webp',
        'VPR02601_Vasso_Paraschi.webp',
        'VPR02616_Vasso_Paraschi.webp',
        'VPR02618_Vasso_Paraschi.webp',
        'VPR02735_Vasso_Paraschi.webp',
        'VPR02746_Vasso_Paraschi.webp',
        'VPR02791_Vasso_Paraschi.webp',
        'VPR02829_Vasso_Paraschi.webp',
        'VPR02846-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR02853_Vasso_Paraschi.webp',
        'VPR02930_Vasso_Paraschi.webp',
        'VPR02933_Vasso_Paraschi.webp',
        'VPR03031_Vasso_Paraschi.webp',
        'VPR03058_Vasso_Paraschi.webp',
        'VPR03092-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03144-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03372_Vasso_Paraschi.webp',
        'VPR03377_Vasso_Paraschi.webp',
        'VPR03382_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Bathrooms")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default BathroomPage;
